const STALE_CHUNK_RELOAD_KEY_PREFIX = "plusbake:stale-chunk-reload"
let staleChunkReloadAttemptedInMemory = false

function getErrorText(error: unknown) {
  if (error instanceof Error) {
    return [error.name, error.message, error.stack].filter(Boolean).join(" ")
  }

  return String(error ?? "")
}

function getChunkReloadKey(errorText: string) {
  const assetPath = errorText.match(/\/assets\/[^\s"'()]+\.js/)?.[0]

  return `${STALE_CHUNK_RELOAD_KEY_PREFIX}:${assetPath ?? window.location.pathname}`
}

export function isStaleChunkLoadError(error: unknown) {
  const errorText = getErrorText(error).toLowerCase()

  return (
    errorText.includes("failed to fetch dynamically imported module") ||
    errorText.includes("error loading dynamically imported module") ||
    errorText.includes("importing a module script failed") ||
    errorText.includes("chunkloaderror") ||
    errorText.includes("loading chunk") ||
    errorText.includes("loading css chunk") ||
    (errorText.includes("module script") &&
      errorText.includes("mime type") &&
      errorText.includes("text/html"))
  )
}

export function reloadOnceForStaleChunk(error: unknown) {
  if (typeof window === "undefined" || !isStaleChunkLoadError(error)) {
    return false
  }

  const key = getChunkReloadKey(getErrorText(error))

  try {
    if (window.sessionStorage.getItem(key)) {
      return false
    }

    window.sessionStorage.setItem(key, "1")
  } catch {
    if (staleChunkReloadAttemptedInMemory) {
      return false
    }

    staleChunkReloadAttemptedInMemory = true
  }

  window.location.reload()
  return true
}
